import {
  STATUS_REQUERIMENTO,
  MSG_TOOLTIP_SALVAR_TEXTO,
  MSG_TOOLTIP_SALVAR_DEVOLVER,
  MSG_TOOLTIP_FINALIZAR,
  MSG_TOOLTIP_ENCAMINHAR,
  MSG_TOOLTIP_ADICIONAR_ANALISE,
  MSG_TOOLTIP_ADICIONAR_ATENDIMENTO,
  MSG_TOOLTIP_CANCELAR,
} from 'utils/consts';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { replaceFromTagHtml } from 'utils/funcaoPadrao';

export const verificarButtonAnalise = statusIndeferidor => {
  const retorno = { showButtonAddAnalise: false, showButtonRemoveAnalise: false };

  if (
    statusIndeferidor === STATUS_REQUERIMENTO.FINALIZADO_DEFERIDO.identificador ||
    statusIndeferidor === STATUS_REQUERIMENTO.FINALIZADO_INDEFERIDO.identificador ||
    statusIndeferidor === STATUS_REQUERIMENTO.FINALIZADO_PROCESSO_GERADO.identificador ||
    statusIndeferidor === STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE.identificador ||
    statusIndeferidor === STATUS_REQUERIMENTO.REATENDIMENTO.identificador ||
    statusIndeferidor === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador
  ) {
    retorno.showButtonAddAnalise = false;
    retorno.showButtonRemoveAnalise = false;
  }
  if (statusIndeferidor === STATUS_REQUERIMENTO.EM_ANALISE.identificador) {
    retorno.showButtonAddAnalise = false;
    retorno.showButtonRemoveAnalise = true;
  }
  if (statusIndeferidor === STATUS_REQUERIMENTO.EM_ATENDIMENTO.identificador) {
    retorno.showButtonAddAnalise = true;
    retorno.showButtonRemoveAnalise = false;
  }
  return retorno;
};

export const getMensagemTooltip = (exibirBtnAdicionarAnalise, exibirBtnRemoverAnalise, userProfile) => {
  let mensagemTooltip = '';

  mensagemTooltip += replaceFromTagHtml(MSG_TOOLTIP_SALVAR_TEXTO, 'Salvar Texto:', 'Justificativa');
  mensagemTooltip += replaceFromTagHtml(MSG_TOOLTIP_SALVAR_DEVOLVER, 'Salvar e Devolver:', 'Justificativa');
  mensagemTooltip += replaceFromTagHtml(MSG_TOOLTIP_FINALIZAR, 'Finalizar Atendimento:', 'Justificativa');
  mensagemTooltip += replaceFromTagHtml(MSG_TOOLTIP_ENCAMINHAR, 'Encaminhar Atendimento:', '');

  if (exibirBtnAdicionarAnalise) {
    mensagemTooltip += replaceFromTagHtml(MSG_TOOLTIP_ADICIONAR_ANALISE, 'Alterar para Em Análise:', '');
  }
  if (exibirBtnRemoverAnalise) {
    mensagemTooltip += replaceFromTagHtml(
      MSG_TOOLTIP_ADICIONAR_ATENDIMENTO,
      'Alterar para Em Atendimento:',
      'Justificativa'
    );
  }
  if (userProfile === ENUM_TIPO_PERFIL.SUPERVISOR) {
    mensagemTooltip += replaceFromTagHtml(MSG_TOOLTIP_CANCELAR, 'Cancelar Requerimento:', 'Justificativa');
  }

  return (
    <td
      dangerouslySetInnerHTML={{
        __html: mensagemTooltip,
      }}
    />
  );
};
